import React from "react";
import * as NEWS_ROUTES from "../../../Router/news_routes";
import { ButtonTertiary } from "../../Button";
import { Link } from "react-router-dom";

const AgencyInformation = () => {
  const sections = [
    {
      key: "famTrips",
      backgroundColor: "#9BCB40",
      label: "Fam Trips",
      route: NEWS_ROUTES.FRONTEND.FAM_TRIPS,
      icon: "fal fa-suitcase-rolling",
      description:
        "Find new and exciting fam trip opportunities from our trusted venue partners, support you teams venue knowledge and experience first-hand what your clients can expect.",
    },
    {
      key: "moversAndShakers",
      backgroundColor: "#E6144C",
      label: "Movers and Shakers",
      route: NEWS_ROUTES.FRONTEND.MOVERS_AND_SHAKERS,
      icon: "fal fa-bolt",
      description:
        "Keep a keen eye on people moving within the M&E industry, supports your industry and commercial relationships.",
    },
    {
      key: "renovationNews",
      backgroundColor: "#1B2E5E",
      label: "Renovation News",
      route: NEWS_ROUTES.FRONTEND.RENOVATION_NEWS,
      icon: "fal fa-paint-roller",
      description:
        "Make sure your venue knowledge is second to none, wow your clients and be the first to share news on exciting refurbishments.",
    },
    {
      key: "agencyRates",
      backgroundColor: "#FCA342",
      label: "Agency Rates",
      route: NEWS_ROUTES.FRONTEND.AGENCY_RATES,
      icon: "fal fa-percent",
      description:
        "Gain access to industry leading agency rates from our community of venues, ideal for supporting your business and leisure travel all while building your venue knowledge and supporting your venue relationships.",
    },
  ];

  return (
    <div className="mt-4">
      <div className="mt-4 -mx-2 -mb-4">
        <div className="flex flex-wrap">
          {sections.map(
            ({ key, icon, backgroundColor, label, description, route }) => (
              <div key={key} className="w-full md:w-1/2 px-2 mb-4">
                <div className="p-4 h-full flex flex-col border border-grey items-center">
                  <div
                    className="w-full h-24 mb-4 flex items-center justify-center"
                    style={{ backgroundColor }}
                  >
                    <span className="text-white text-4xl">
                      <i className={icon}></i>
                    </span>
                  </div>
                  <h3 className="text-center text-base font-semibold mb-2">
                    {label}
                  </h3>
                  {description ? (
                    <p className="flex-1 text-center mb-5">{description}</p>
                  ) : null}
                  <Link to={route}>
                    <ButtonTertiary>View more</ButtonTertiary>
                  </Link>
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default AgencyInformation;
